import { computed } from "vue";
import currencyFormat from "@/apps/credit-line/helpers/currencyFormatter.helper";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useNewLimitIncreaseOffer() {
  const { summary } = useCreditLineSummary();

  const newLimitPromotion = computed(() => {
    return (
      summary.value?.messages?.find(
        (msg) =>
          msg?.functionality === "LIMIT_INCREASE" ||
          msg?.functionality === "SP_LIMIT_INCREASE"
      ) ?? null
    );
  });

  const promotionSignRequired = computed(() =>
    Boolean(
      summary.value?.promotions?.find(
        (promo) => promo.functionality === "SP_LIMIT_INCREASE"
      ) ?? false
    )
  );

  const showLimitIncreasePromotionBanner = computed(() => {
    return Boolean(
      summary.value?.promotions?.find((promo) =>
        promo.internalLink?.includes("/creditline/limit-increase-acceptance/")
      ) ?? false
    );
  });

  const newLimitOfferExpiry = computed(() => {
    return newLimitPromotion.value
      ? new Date(
          Number(newLimitPromotion.value.extras?.expirationDateUnixTimestamp) *
            1000
        ).toLocaleDateString(undefined, { day: "2-digit", month: "2-digit" })
      : undefined;
  });

  const newCreditLimit = computed(() => {
    const message =
      summary.value?.messages?.find(
        (msg) =>
          msg?.functionality === "LIMIT_INCREASE" ||
          msg?.functionality === "SP_LIMIT_INCREASE"
      ) ?? null;
    return currencyFormat(
      message?.extras?.unformattedLimitIncreaseAmount ?? 0,
      0
    );
  });

  return {
    promotionSignRequired,
    showLimitIncreasePromotionBanner,
    newLimitOfferExpiry,
    newCreditLimit,
  };
}
